import React from 'react';

import { Icon } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const Container = styled.div`
  cursor: pointer;
  padding: 0;
  margin-left: 10px;
  display: flex;
  align-items: center;
  svg {
    width: 16px;
    min-width: 16px;
  }
`;

const Message = styled.div`
  font-size: 12px;
  display: inline;
  margin-left: 4px;
  color: ${Styles.color.red};
  text-decoration: underline;
  font-weight: bold;
`;

interface IUnverifiedMethodProps {
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const UnverifiedMethod: React.FC<IUnverifiedMethodProps> = ({ onClick }) => {
  const { formatMessage } = useIntl();
  return (
    <Container data-testid="unverified-method-badge" onClick={onClick}>
      <Icon icon="error" color="text-error" aria-hidden />
      <Message>{formatMessage({ id: 'unverified' })}</Message>
    </Container>
  );
};
